export const ADS = 'ADS';
export const AD = 'AD';


// WEBPACK FOOTER //
// ./src/store/modules/ad/mutation-types.js